/// <amd-module name="Feed/IvyPromote/Redux/IvyPromote/IvyPromoteModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";

import { IIvyPromoteOwnState } from "./IvyPromoteContracts";
import { ivyPromoteReducer } from "./IvyPromoteReducers";
import rootSaga from "./IvyPromoteSaga";

const _ivyPromoteModule: ISagaModule<IIvyPromoteOwnState> = {
    id: "feed-ivy-promote",
    reducerMap: {
        ivyPromoteState: ivyPromoteReducer
    },
    sagas: [rootSaga]
};

export const IvyPromoteModule = [_ivyPromoteModule];
